import {PAYMENT_PROVIDERS_TYPE_TO_SLUG} from '../../../common/constants/payment-providers';

const getPaymentSlugByValue = (paymentProvider) =>
  Object.keys(PAYMENT_PROVIDERS_TYPE_TO_SLUG).find(
    (key) => PAYMENT_PROVIDERS_TYPE_TO_SLUG[key] === paymentProvider
  );

export default getPaymentSlugByValue;
